import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { IonButton, IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectivityService } from '@okcargo-apps/shared-infrastructure';
import { UploadDocumentModalComponent } from '../upload-document-modal/upload-document-modal.component';

@Component({
  selector: 'lib-upload-document-button',
  templateUrl: './upload-document-button.component.html',
  styleUrls: ['./upload-document-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonIcon, IonButton, TranslateModule],
})
export class UploadDocumentButtonComponent {
  private readonly modalCtrl = inject(ModalController);
  private readonly connectivity = inject(ConnectivityService);

  /** Uploading a document is a command: it cannot be done without connection. */
  protected readonly isOffline = this.connectivity.isOffline;

  @Input()
  documentType: any;

  async showUploadDocumentModal(): Promise<void> {
    if (this.isOffline()) return;

    const modal = await this.modalCtrl.create({
      component: UploadDocumentModalComponent,
      componentProps: {
        documentType: this.documentType,
      },
      backdropDismiss: false,
    });
    modal.present();
  }
}
